/**
 * US states + DC + territories, ISO-3166-2 codes. Used by the
 * US payroll dialog so the state-tax engine sees only valid codes
 * instead of free-text "calforina" / "TX " etc.
 *
 * Ordered: 50 states alphabetically, then DC, then inhabited
 * territories (treated by the IRS as withholding jurisdictions).
 */
export const US_STATES: Array<{ code: string; name: string }> = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
  { code: 'DC', name: 'District of Columbia' },
  { code: 'PR', name: 'Puerto Rico' },
  { code: 'GU', name: 'Guam' },
  { code: 'VI', name: 'U.S. Virgin Islands' },
  { code: 'AS', name: 'American Samoa' },
  { code: 'MP', name: 'Northern Mariana Islands' },
];

/**
 * Common UK tax codes for the payroll dialog's datalist. Tax codes
 * are open-ended ("1257L" + suffix variants, K-codes, emergency
 * codes, BR/D0/D1/NT), so we ship the typical ones as suggestions
 * while still allowing free text entry. HMRC issues thousands of
 * variants; this list covers ~95% of UK payroll runs.
 */
export const UK_COMMON_TAX_CODES: string[] = [
  '1257L',  // Standard personal allowance FY26
  '1257L W1', '1257L M1',  // Emergency, week-1/month-1 basis
  '1257L X', // Combined W1/M1 marker
  'BR',     // Basic-rate (no allowance)
  'D0',     // All income at higher rate
  'D1',     // All income at additional rate
  'NT',     // No tax
  '0T',     // No personal allowance
  'K475',   // K-code: untaxed benefits exceed allowance
  'K500',
  'K1000',
  'S1257L', // Scottish standard
  'C1257L', // Welsh standard
];
